import { Component,Input } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { StorageService } from '../../../../Common/services/storage.service';
import { GinfoSpProjectDetailsVm, SalesplanGeneralInfoVm } from '../../../models/salesplan-vm';
import moment from 'moment';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { RoleKey } from '../../../../Common/Constants/common.constants';
import { RolesKeysConstants } from '../../../../Common/Constants/data';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'ginfo-salesplan-details',
  templateUrl: './ginfo-salesplan-details.component.html',
  styleUrl: './ginfo-salesplan-details.component.css'
})
export class GeneralInfoSalesplanDetailsComponent {
  sreUsers: any = [];
  productFLowsList: any = [];
  selectedproductFLow: any[] = [];
  displayTypes: any = [];
  selectedDisplayType : number = 0;
  selectedSreSpoc : number = 0;
  @Input() selectedGenInfoSpProject! : GinfoSpProjectDetailsVm;
  @Input() enablePWR: boolean = false;
  @Input() disableAfterReview: boolean = false;
  madbDate: Date | null | undefined;
  eventIdDisable: boolean = false;
  locations: any = [];
  selectedLocation : number = 0;

  constructor(private storageService: StorageService,
    private projectService: ProjectService,
    private userRoleService: UserRoleServiceService,
  private unsavedChangesService: UnsavedChangesService) {
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

 async ngOnInit()
 {
  let vendorDetails = this.storageService.getItem<any>("selectedVendor");

  this.projectService.getSREUsers(vendorDetails.vendorID).subscribe(data =>{
    this.sreUsers = data;
  });
  this.getLocations();
  this.projectService.getDisplayType().subscribe(data =>{
    this.displayTypes = data;
  });

  this.projectService.getPRoductFlows().subscribe(data =>{
    let prodFLowList = data.map((x: any) => ({ 'label': x.productFlowDescription, 'productFlowID': x.categoryID }));
    this.productFLowsList = data;
  });

  this.selectedLocation = this.selectedGenInfoSpProject.locationId;
  this.selectedDisplayType = this.selectedGenInfoSpProject.displayType;
  this.selectedSreSpoc = this.selectedGenInfoSpProject.sreSpoc;
  if(this.selectedGenInfoSpProject.mabd != null){
    this.madbDate = new Date(this.selectedGenInfoSpProject.mabd);
    this.selectedGenInfoSpProject.madbStr = moment(this.selectedGenInfoSpProject.mabd).format('DD-MMM-yyyy');       
  }

  // let ctRole = (await this.userRoleService.getUserRoles())
  //                   .some(role => role.roleKey.includes(RolesKeysConstants.RoleKey_CustomerTeam));

  if(this.userRoleService.role!.roleKey == RolesKeysConstants.RoleKey_CustomerTeam){
    this.eventIdDisable = true;
  }
  else
  {
    this.eventIdDisable = false;
  }
 }

 getLocations(){
  this.projectService.getLocations().subscribe(data =>{
    this.locations = data;
  });
 }

 onSelectedProductFLow(selectedValues: number[]) {
  this.unsavedChangesService.setUnsavedChanges(true);
  //this.salesplanModel.selectedCategories = selectedValues; 
  //this.getProductsByCategories();   
}

 onSelectedSreSpoc(){
  this.selectedGenInfoSpProject.sreSpoc = this.selectedSreSpoc;
 }
 
 onSelectedLocation(){
  this.selectedGenInfoSpProject.locationId = this.selectedLocation;
 }
 onSelectedDisplayType(){
  this.selectedGenInfoSpProject.displayType = this.selectedDisplayType;
 }
 validateFields(): string[]
 {
   let validationMessages: string[] = []
   if(this.selectedGenInfoSpProject.projectTitle.length == 0)
   {
     validationMessages.push("Event Title is required");
   }

  //  if(this.selectedGenInfoSpProject.sreSpoc <= 0)
  //  {
  //    validationMessages.push("SRE SPOC is required");
  //  }

   return validationMessages;
 }
 
 async onMadbDateChange(ev:any){
  this.unsavedChangesService.setUnsavedChanges(true);
  this.selectedGenInfoSpProject.madbStr = moment(ev).format('DD-MMM-yyyy');       
  this.madbDate = ev;
 }
}
